export const getCookie = (key: string): any => {
  if (typeof document !== 'undefined' && document?.cookie) {
    return document?.cookie
      ?.split('; ')
      ?.find((row) => row.startsWith(`${key}=`))
      ?.split('=')[1];
  }
};

export const unsetCookie = (cookie: string): any => {
  if (typeof document !== 'undefined' && document?.cookie) {
    const currentTime = new Date().toUTCString();
    document.cookie = `${cookie}; expires=${currentTime}; path=/`;
  }
};

/**
 * Util function used for setting preview cookie client side
 */
export const setCookie = (
  name: string,
  value: string,
  minutes?: number
): any => {
  if (typeof document !== 'undefined' && document?.cookie) {
    let expires = '';
    if (minutes) {
      const date = new Date();
      date.setTime(date.getTime() + minutes * 60 * 1000);
      expires = '; expires=' + date.toUTCString();
    }
    document.cookie =
      name +
      '=' +
      (value || '') +
      expires +
      '; path=/' +
      '; SameSite=None' +
      '; Secure';
  }
};
